<div *ngIf="loadComplete" class="container-block">
  <button class="ant-btn ant-btn-primary d-flex align-items-center"
    (click)="configMode == 'basic' ? configMode = 'advanced' : configMode = 'basic'">
    <i nz-icon nzType="setting" nzTheme="outline"></i>
    <span>{{(configMode == 'basic' ? 'cau_hinh_nang_cao' : 'cau_hinh_co_ban') | translate}}</span>
  </button>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <!-- Chọn option nền cho frame blank -->
      <app-background-image-config [showImageConfig]="false" [elementChoosing]="objectChoosing" [config]="config" [class]="class"
        [backgroundClass]="class['frame-category-detail']" [backgroundConfig]="config['frame-category-detail']"
        [id_object]="objectChoosing._id" [isBlock]="false" [device]="device">
      </app-background-image-config>
    </div>
  </ng-container>

  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <ul nz-menu nzMode="inline">
      <!-- Cấu hình tái sử dụng thiết kế-->

      <li nz-submenu nzTitle="{{'thong_so_co_ban' | translate}}" [(nzOpen)]="openMenu.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <div class="main-config">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>

          <!-- Chọn option nền cho frame blank -->
          <app-background-image-config [showImageConfig]="false" [elementChoosing]="objectChoosing" [config]="config" [class]="class"
            [backgroundClass]="class['frame-category-detail']" [backgroundConfig]="config['frame-category-detail']"
            [id_object]="objectChoosing._id" [isBlock]="false" [device]="device">
          </app-background-image-config>
        </div>
      </li>
      <!-- Cấu hình đường viền chung -->
      <li nz-submenu nzTitle="{{'duong_vien_chung' | translate}}" [(nzOpen)]="openMenu.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <app-borders-config [device]="device" [elementChoosing]="objectChoosing" [class]="class"
          [borderClass]="class['frame-category-detail']" [id_object]="objectChoosing._id">
        </app-borders-config>
        <!-- Nút mở rộng -->
        <div class="item-border" style="float: right;">
          <p class="m-0 title-border" (click)="openViewAll(stylesField[0])">{{'mo_rong' | translate}} &#8594;</p>
        </div>
      </li>

      <!-- canh lề -->
      <li nz-submenu nzTitle="{{'canh_le' | translate}}" nzIcon="" [(nzOpen)]="openMenu.menu3"
        (nzOpenChange)="openHandler('menu3')">
        <div>
          <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
            [classPadding]="class['frame-category-detail']" [paddingConfigs]="[
              { type: 'top' },
              { type: 'bottom' },
              { type: 'left' },
              { type: 'right' }
            ]">
          </app-padding-config>
        </div>
      </li>

      <!-- đổ bóng -->
      <li nz-submenu nzTitle="{{'do_bong' | translate}}" nzIcon="" [(nzOpen)]="openMenu.menu5"
        (nzOpenChange)="openHandler('menu5')">
        <div>
          <app-shadow-config [device]="device" [config]="config" [class]="class" [shadowClass]="class['frame-category-detail']"
            [shadowConfig]="config['box-shadow']" [objectChoosing]="objectChoosing">
          </app-shadow-config>
        </div>
      </li>
    </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình frame -->
  <div class="view-more" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{currentViewAll.title | translate}}</span>
    <!-- Cấu hình chi tiết viền của frame -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['frame-category-detail']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
  </div>
</div>